import {  mapActions } from "vuex";

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design
import { autoSize } from "./autoSize";
export default {
  watch: {
    $route() {

    }
  },
  beforeMount() {
    // window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      autoSize()
      this["app/toggleDevice"]('mobile')
      document.body.classList.remove('body-desktop')
      document.body.classList.add('body-mobile')
    }else{
      document.body.classList.remove('body-mobile')
      document.body.classList.add('body-desktop')
      // document.documentElement.style.fontSize =  "16px";
    }
  },
  methods: {
      ...mapActions(["app/toggleDevice"]),
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        console.log(isMobile ? 'mobile' : 'desktop','isMobile')
        if(isMobile){
          document.body.classList.remove('body-desktop')
          document.body.classList.add('body-mobile')
          
          autoSize()
        }else{
          document.body.classList.remove('body-mobile')
          document.body.classList.add('body-desktop')
          // document.documentElement.style.fontSize =  "16px";
        }
        this["app/toggleDevice"](isMobile ? 'mobile' : 'desktop')
      }
    }
  }
}
